/* Restlab theme – liten, avhengighetsfri JS.
   Handlekurv-panel, varianter, mengdevelger, filter/sortering, anbefalte produkter. */
(function () {
  'use strict';

  var RL = window.RL || { cartType: 'page', routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };
  var root = document.documentElement;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Handlekurv-panel ---------- */
  function drawerEl() { return qs('[data-drawer]'); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) { window.location.href = RL.routes.cart; return; }
    root.classList.add('drawer-open');
    d.setAttribute('aria-hidden', 'false');
    var panel = qs('.drawer__panel', d);
    if (panel) { panel.focus(); }
  }

  function closeDrawer() {
    var d = drawerEl();
    root.classList.remove('drawer-open');
    if (d) { d.setAttribute('aria-hidden', 'true'); }
  }

  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  function refreshCart() {
    return Promise.all([
      fetch(RL.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(RL.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = new DOMParser().parseFromString(res[0]['cart-drawer'], 'text/html');
      var fresh = html.getElementById('CartDrawerContent');
      var current = document.getElementById('CartDrawerContent');
      if (fresh && current) { current.innerHTML = fresh.innerHTML; }
      updateCount(res[1].item_count);
    });
  }

  function showError(form, message) {
    var el = qs('[data-form-error]', form);
    if (!el) { return; }
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(form) {
    var el = qs('[data-form-error]', form);
    if (el) { el.hidden = true; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) { return; }

    // Åpne panel fra handlekurv-ikonet
    var cartLink = t.closest('[data-cart-link]');
    if (cartLink && RL.cartType === 'drawer' && drawerEl()) {
      e.preventDefault();
      refreshCart().then(openDrawer, openDrawer);
      return;
    }

    // Lukk panel
    if (t.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    // Endre antall / fjern linje i panelet
    var lineBtn = t.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      lineBtn.disabled = true;
      fetch(RL.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(lineBtn.dataset.line, 10), quantity: parseInt(lineBtn.dataset.quantity, 10) })
      }).then(function () { return refreshCart(); })
        .catch(function () { window.location.href = RL.routes.cart; });
      return;
    }

    // Mengde +/- på produktsiden
    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = t.closest('[data-qty]');
      var input = qs('input', wrap);
      var val = parseInt(input.value, 10) || 1;
      input.value = plus ? val + 1 : Math.max(1, val - 1);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('drawer-open')) { closeDrawer(); }
  });

  /* ---------- Legg i handlekurv (AJAX når panel er valgt) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) { return; }
    if (RL.cartType !== 'drawer' || !drawerEl()) { return; }

    e.preventDefault();
    clearError(form);
    var btn = qs('[type="submit"]', form);
    if (btn) { btn.disabled = true; }

    fetch(RL.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) {
        showError(form, res.data.description || res.data.message || '');
        return;
      }
      return refreshCart().then(openDrawer);
    }).catch(function () {
      form.submit();
    }).then(function () {
      if (btn) { btn.disabled = false; }
    });
  });

  /* ---------- Automatisk innsending (sortering, filter, antall på kurv-side) ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-autosubmit]') && el.form) {
      el.form.submit();
    }
    var form = el.form;
    if (form && form.matches && form.matches('[data-collection-form]') && el.type === 'checkbox') {
      form.submit();
    }
  });

  /* ---------- Produktside: varianter + galleri ---------- */
  function initProduct(section) {
    var jsonEl = document.getElementById(section.dataset.variantsId);
    if (!jsonEl) { return; }
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = qs('[data-main-form]', section);
    var idInput = qs('[data-variant-id]', form);
    var addBtn = qs('[data-add-button]', form);
    var addLabel = qs('[data-add-label]', form);
    var priceNow = qs('[data-price-now]', section);
    var priceWas = qs('[data-price-was]', section);

    function showMedia(id) {
      if (!id) { return; }
      var found = false;
      qsa('.pdp__slide', section).forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(id);
        if (on) { found = true; }
      });
      if (!found) { return; }
      qsa('.pdp__slide', section).forEach(function (s) {
        s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id));
      });
      qsa('.pdp__thumb', section).forEach(function (b) {
        b.classList.toggle('is-active', String(b.dataset.mediaTarget) === String(id));
      });
    }

    function selectedOptions() {
      return qsa('[data-option-index]', form).map(function (fs) {
        var checked = qs('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function applyVariant(v) {
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = addBtn.dataset.labelUnavailable;
        return;
      }
      idInput.value = v.id;
      priceNow.textContent = v.price;
      if (v.compare) { priceWas.textContent = v.compare; priceWas.hidden = false; } else { priceWas.hidden = true; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      showMedia(v.media);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('.option__input')) { return; }
      var chosen = selectedOptions();
      var match = null;
      variants.forEach(function (v) {
        var same = v.options.every(function (o, i) { return o === chosen[i]; });
        if (same) { match = v; }
      });
      applyVariant(match);
    });

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest ? e.target.closest('[data-media-target]') : null;
      if (thumb) { showMedia(thumb.dataset.mediaTarget); }
    });
  }

  qsa('[data-product-section]').forEach(initProduct);

  /* ---------- Anbefalte produkter ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url || el.querySelector('.grid')) { return; }
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; }
    }).catch(function () { /* stille */ });
  });

  /* ---------- Lukk mobilmeny ved klikk utenfor ---------- */
  document.addEventListener('click', function (e) {
    var open = qs('.mobile-menu[open]');
    if (open && !open.contains(e.target)) { open.removeAttribute('open'); }
  });
})();